// extracted by mini-css-extract-plugin
export default {"legalNotice":"_3flataKDIlJmeSjxnbN6Vx"};